import { AxiosResponse } from "axios";
import apiClient from "../apiClient/apiClient";
import { useQuery } from 'react-query';
import { Package, Strategy } from "./strategy.types";


export const useGetStrategies = () => {
    return useQuery<AxiosResponse<Strategy[]>>(
        'getStrategies',
        () => apiClient.get<Strategy[]>('/strategies')
    )
}

export const useGetStrategy = (
    strategyNo: string
) => {
  return useQuery<AxiosResponse<Strategy>>({
    queryKey: ['getStrategy', strategyNo],
    queryFn: () => apiClient.get<Strategy>(`/strategies/${strategyNo}`)
  })
}

export const useGetStrategyPackages = (
    strategyNo: string
) => {
  return useQuery<AxiosResponse<Package[]>>({
    queryKey: ['getStrategyPackages', strategyNo],
    queryFn: () => apiClient.get<Package[]>(`/strategies/${strategyNo}/packages`)
  })
}

export const useGetMenuItemRecipeStrategies = (
    menuNo: string,
    enabled: boolean = false
) => {
    return useQuery<AxiosResponse<Strategy[]>>({
        queryKey: ['getMenuItemRecipeStrategies', menuNo],
        queryFn: () => apiClient.get<Strategy[]>(`/menus/${menuNo}/items/recipes/strategies`),
        enabled
    });
};